import { COMPANY_NAME, SITE_DOMAIN, SITE_URL } from './site';

export { COMPANY_NAME };

export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS_FULL = `${ADDRESS_LINE1}, ${ADDRESS_LINE2}`;

export const CONTACT = {
  email: `support@${SITE_DOMAIN}`,
  website: SITE_DOMAIN,
  websiteUrl: SITE_URL,
  company: COMPANY_NAME,
  addressLine1: ADDRESS_LINE1,
  addressLine2: ADDRESS_LINE2,
  address: ADDRESS_FULL,
};
